/**
 * B-Design Icon name format
 * Input: name: 'Member management', type: 'outlined'
 * Output: 'a-Membermanagement-outlined'
 * @param {string} name Icon name
 * @param {'outlined'|'filled'} type Icon style type
 * @return {string} Formatted icon type name.
 */
export const iconNameToTypeProps = (name, type) => {
    let formattedName;
    if (name.indexOf(' ') > -1) {
        formattedName = 'a-' + name.split(' ').join('');
    }
    else {
        formattedName = name;
    }
    return `${formattedName}-${type}`;
};
export const pictogramProps = (name) => {
    let formattedName;
    if (name.indexOf(' ') > -1) {
        formattedName = name.toLowerCase().split(' ').join('-');
    }
    else {
        formattedName = name.toLowerCase();
    }
    return `${formattedName}`;
};
const LEGACY_ICON_TO_3 = {
    'a-Chevronup-outlined': 'chevron--up',
    'a-Chevronup-filled': 'chevron--up',
    'a-Chevrondown-outlined': 'chevron--down',
    'a-Chevrondown-filled': 'chevron--down',
    'a-Chevronleft-outlined': 'chevron--left',
    'a-Chevronleft-filled': 'chevron--left',
    'a-Chevronright-outlined': 'chevron--right',
    'a-Chevronright-filled': 'chevron--right',
    'Add-outlined': 'add',
    'Add-filled': 'add--circle--filled',
    'Subtract-outlined': 'subtract',
    'Subtract-filled': 'subtract--circle--filled',
    'Close-outlined': 'close',
    'Close-filled': 'misuse--filled',
    'a-Overflowmenuhorizontal-outlined': 'overflow-menu--horizontal',
    'a-Overflowmenuhorizontal-filled': 'overflow-menu--horizontal',
    'a-Overflowmenuvertical-outlined': 'overflow-menu--vertical',
    'a-Overflowmenuvertical-filled': 'overflow-menu--vertical',
    'Menu-outlined': 'list',
    'Menu-filled': 'list',
    'Apps-outlined': 'apps--outline',
    'Apps-filled': 'apps--filled',
    'Home-outlined': 'home--outline',
    'Home-filled': 'home--filled',
    'Search-outlined': 'search',
    'Search-filled': 'search',
    'a-Zoomin-outlined': 'zoom-in',
    'a-Zoomin-filled': 'zoom-in',
    'a-Zoomout-outlined': 'zoom-out',
    'a-Zoomout-filled': 'zoom-out',
    'Shrink-outlined': 'substract--square--outline',
    'Shrink-filled': 'substract--square--filled',
    'Unfolded-outlined': 'add--square--outline',
    'Unfolded-filled': 'add--square--filled',
    'Thumbnail-filled': 'thumbnail-alt',
    'Thumbnail-outlined': 'thumbnail-alt',
    'Chocolate-outlined': 'menu',
    'Chocolate-filled': 'menu',
    'a-Viewmodule-filled': 'apps--filled',
    'a-Viewmodule-outlined': 'apps--outline',
    'a-Viewcolumn-filled': 'apps--filled',
    'a-Viewcolumn-outlined': 'apps--outline',
    'a-Viewagenda-filled': 'apps--filled',
    'a-Viewagenda-outlined': 'apps--outline',
    'a-Viewcarousel-filled': 'apps--filled',
    'a-Viewcarousel-outlined': 'apps--outline',
    'Unfold-outlined': 'put-away--right',
    'Unfold-filled': 'put-away--right',
    'a-Packup-outlined': 'put-away--left',
    'a-Packup-filled': 'put-away--left',
    'Move-outlined': 'move',
    'Move-filled': 'move',
    'a-Draggable1-filled': 'draggable',
    'a-Draggable1-outlined': 'draggable',
    'a-Draggable2-filled': 'draggable',
    'a-Draggable2-outlined': 'draggable',
    'a-Draghorizontal-outlined': 'move',
    'a-Draghorizontal-filled': 'move',
    'a-Dragvertical-outlined': 'move',
    'a-Dragvertical-filled': 'move',
    'Compare-outlined': '',
    'Compare-filled': '',
    'Ascending-outlined': 'ascending',
    'Ascending-filled': 'ascending',
    'a-Descendingorder-outlined': 'descending',
    'a-Descendingorder-filled': 'descending',
    'Maximize-outlined': 'maximize',
    'Maximize-filled': 'maximize',
    'Minimize-outlined': 'minimize',
    'Minimize-filled': 'minimize',
    'a-Arrowshorizontal1-filled': '',
    'a-Arrowshorizontal1-outlined': '',
    'a-Arrowshorizontal2-filled': '',
    'a-Arrowshorizontal2-outlined': '',
    'a-Arrowsvertical1-filled': 'arrows--vertical',
    'a-Arrowsvertical1-outlined': 'arrows--vertical',
    'a-Arrowsvertical2-filled': 'arrows--vertical',
    'a-Arrowsvertical2-outlined': 'arrows--vertical',
    'Arrow-up-filled': 'arrow--up',
    'Arrow-up-outlined': 'arrow--up',
    'Arrow-down-filled': 'arrow--down',
    'Arrow-down-outlined': 'arrow--down',
    'Arrow-left-filled': 'arrow--left',
    'Arrow-left-outlined': 'arrow--left',
    'Arrow-right-filled': 'arrow--right',
    'Arrow-right-outlined': 'arrow--right',
    'a-Caretup-outlined': 'caret--up',
    'a-Caretup-filled': 'caret--up',
    'a-Caretdown-outlined': 'caret--down',
    'a-Caretdown-filled': 'caret--down',
    'a-Caretleft-outlined': 'caret--left',
    'a-Caretleft-filled': 'caret--left',
    'a-Caretright-filled': 'caret--right',
    'a-Caretright-outlined': 'caret--right',
    'a-Caretsort-outlined': 'caret--sort',
    'a-Caretsort-filled': 'caret--sort',
    'Undo-outlined': 'undo',
    'Undo-filled': 'undo',
    'Redo-outlined': 'redo',
    'Redo-filled': 'redo',
    'Upgrade-outlined': '',
    'Upgrade-filled': '',
    'a-Commit1-outlined': '',
    'a-Commit1-filled': '',
    'a-Commit2-outlined': '',
    'a-Commit2-filled': '',
    'Logout-outlined': '',
    'Logout-filled': '',
    'Login-outlined': '',
    'Login-filled': '',
    'Send-outlined': 'send--outline',
    'Send-filled': 'send--filled',
    'Slash-outlined': 'slash',
    'Slash-filled': 'slash',
    'Bookmark-outlined': 'bookmark--outline',
    'Bookmark-filled': 'bookmark--filled',
    'Flag-outlined': '',
    'Flag-filled': '',
    'Filter-outlined': 'filter',
    'Filter-filled': 'filter',
    'Renew-outlined': 'renew',
    'Renew-filled': 'renew',
    'Chat-outlined': 'chat--outline',
    'Chat-filled': 'chat--filled',
    'Feedback-outlined': '',
    'Feedback-filled': '',
    'Random-outlined': '',
    'Random-filled': '',
    'Notification-outlined': '',
    'Notification-filled': '',
    'a-Notificationoff-outlined': '',
    'a-Notificationoff-filled': '',
    'Locked-outlined': '',
    'Locked-filled': '',
    'Unlocked-outlined': 'unlocked--outline',
    'Unlocked-filled': 'unlocked--filled',
    'Fixed-outlined': 'pin--outline',
    'Fixed-filled': 'pin--filled',
    'a-Removefixed-outlined': '',
    'a-Removefixed-filled': '',
    'View-outlined': 'view--outline',
    'View-filled': 'view--filled',
    'a-Viewoff-outlined': 'view--off--outline',
    'a-Viewoff-filled': 'view--off--filled',
    'a-Thumbsup-outlined': 'thumbs-up--outline',
    'a-Thumbsup-filled': 'thumbs-up--filled',
    'Awake-outlined': 'idea--outline',
    'Awake-filled': 'idea--filled',
    'Asleep-outlined': '',
    'Asleep-filled': '',
    'Star-outlined': 'star--outline',
    'Star-filled': 'star--filled',
    'Favorite-outlined': 'favorite--outline',
    'Favorite-filled': 'favorite--filled',
    'Rectangle-filled': '',
    'Rectangle-outlined': '',
    'Polygon-outlined': '',
    'Polygon-filled': '',
    'Creation-outlined': '',
    'Creation-filled': '',
    'Crop-outlined': '',
    'Crop-filled': '',
    'a-Trashcan-outlined': 'trash-can--outline',
    'a-Trashcan-filled': 'trash-can--filled',
    'Color-outlined': '',
    'Color-filled': '',
    'a-Colorpalette-outlined': '',
    'a-Colorpalette-filled': '',
    'Edit-outlined': 'edit--outline',
    'Edit-filled': 'edit--filled',
    'a-Editoff-outlined': '',
    'a-Editoff-filled': '',
    'Link-outlined': 'link',
    'Link-filled': 'link',
    'Unlink-outlined': 'unlink',
    'Unlink-filled': 'unlink',
    'Image-outlined': 'image--outline',
    'Image-filled': 'image--filled',
    'a-Imagedamaged-outlined': 'no-image--outline',
    'a-Imagedamaged-filled': 'no-image--filled',
    'a-3Danimationmodel-filled': '',
    'a-3Danimationmodel-outlined': '',
    'Save-outlined': 'save--outline',
    'Save-filled': 'save--filled',
    'Play-outlined': 'play--outline',
    'Play-filled': 'play--filled',
    'Pause-outlined': 'pause--outline',
    'Pause-filled': 'pause--filled',
    'Stop-outlined': 'stop--outline',
    'Stop-filled': 'stop--filled',
    'Settings-outlined': 'settings--outline',
    'Settings-filled': 'settings--filled',
    'a-Volumedown-outlined': 'volume--down--outlined',
    'a-Volumedown-filled': 'volume--down--filled',
    'a-Volumeup-outlined': 'volume--up--outline',
    'a-Volumeup-filled': 'volume--up--filled',
    'a-Volumemute-outlined': '',
    'a-Volumemute-filled': '',
    'a-Settingsadjust-outlined': '',
    'a-Settingsadjust-filled': '',
    'a-Brandmanagement-outlined': '',
    'a-Brandmanagement-filled': '',
    'a-Storemanagement-outlined': 'store-management--outline',
    'a-Storemanagement-filled': 'store-management--filled',
    'a-Membermanagement-outlined': '',
    'a-Membermanagement-filled': '',
    'a-Shoppingcart-outlined': 'shopping--cart--outline',
    'a-Shoppingcart-filled': 'shopping--cart--filled',
    'Gift-outlined': 'gift--outline',
    'Gift-filled': 'gift--filled',
    'a-Calendar1-outlined': 'calendar--outline',
    'a-Calendar1-filled': 'calendar--filled',
    'a-Calendar2-outlined': 'calendar--outline',
    'a-Calendar2-filled': 'calendar--filled',
    'Time-outlined': 'time--outline',
    'Time-filled': 'time--filled',
    'Checkmark-outlined': 'checkmark--outline',
    'Checkmark-filled': 'checkmark--filled',
    'Misuse-outlined': 'misuse--outline',
    'Misuse-filled': 'misuse--filled',
    'Warning-outlined': 'warning--outline',
    'Warning-filled': 'warning--filled',
    'Help-outlined': 'help--outline',
    'Help-filled': 'help--filled',
    'Information-outlined': 'information--outline',
    'Information-filled': 'information--filled',
    'Error-outlined': 'error--outline',
    'Error-filled': ' error--filled',
    'Pending-outlined': 'pending--outline',
    'Pending-filled': 'pending--filled',
    'a-CheckmarkOrigin-outlined': 'checkmark',
    'Processing-outlined': '',
    'Processing-filled': '',
    'a-New1-outlined': 'new--outline',
    'a-New1-filled': 'new--filled',
    'a-New2-outlined': 'new--outline',
    'a-New2-filled': 'new--filled',
    'Camera-outlined': '',
    'Camera-filled': '',
    'Equipment-outlined': 'equipment--outline',
    'Equipment-filled': 'equipment--filled',
    'Share-outlined': 'share--outline',
    'Share-filled': 'share--filled',
    'Mobile-outlined': 'mobile--outline',
    'Mobile-filled': 'mobile--filled',
    'Computer-outlined': 'computer--outline',
    'Computer-filled': 'computer--filled',
    'Headset-outlined': 'headset--outline',
    'Headset-filled': 'headset--filled',
    'Phone-outlined': 'phone--outline',
    'Phone-filled': 'phone--filled',
    'Supervision-outlined': '',
    'Supervision-filled': '',
    'a-Code1-outlined': 'code',
    'a-Code1-filled': 'code',
    'a-Code2-outlined': 'code--alt--outline',
    'a-Code2-filled': 'code--alt--filled',
    'a-Businessaccess-outlined': 'business-access--outline',
    'a-Businessaccess-filled': 'business-access--filled',
    'a-Cloudupload-outlined': 'cloud--upload',
    'a-Cloudupload-filled': 'cloud--upload',
    'a-Clouddownload-outlined': 'cloud--download',
    'a-Clouddownload-filled': 'cloud--download',
    'Scanning-outlined': 'scanning--outline',
    'Scanning-filled': 'scanning--outline',
    'a-QRcode-outlined': 'scanning--outline',
    'a-QRcode-filled': 'scanning--outline',
    'Email-outlined': 'email--outline',
    'Email-filled': 'email--filled',
    'Bluetooth-outlined': 'bluetooth',
    'Bluetooth-filled': 'bluetooth',
    'a-Bluetoothoff-outlined': 'bluetooth--off',
    'a-Bluetoothoff-filled': 'bluetooth--off',
    'IP-filled': '',
    'IP-outlined': '',
    'API-filled': '',
    'API-outlined': '',
    'Robot-filled': '',
    'Robot-outlined': '',
    'Monitoring-filled': 'cloud--monitoring',
    'Monitoring-outlined': 'cloud--monitoring',
    'Ruler-outlined': '',
    'Ruler-filled': '',
    'a-Ruleralt-outlined': '',
    'a-Ruleralt-filled': '',
    'Telescope-outlined': '',
    'Telescope-filled': '',
    'User-outlined': 'user--outline',
    'User-filled': 'user--filled',
    'a-Userfollow-outlined': 'user--follow--outline',
    'a-Userfollow-filled': 'user--follow--filled',
    'a-Usermultiple-outlined': 'user--multiple--outline',
    'a-Usermultiple-filled': 'user--multiple--filled',
    'a-Usercertification-outlined': 'user--certification--outline',
    'a-Usercertification-filled': 'user--certification--filled',
    'a-Useradmin-outlined': 'user--admin--outline',
    'a-Useradmin-filled': 'user--admin--filled',
    'a-Faceactivated-outlined': 'face--satisfied--outline',
    'a-Faceactivated-filled': 'face--satisfied--filled',
    'a-Facedissatisfied-outlined': 'face--dissatisfied--outline',
    'a-Facedissatisfied-filled': 'face--dissatisfied--filled',
    'a-Usermanagement-outlined': 'user-management--outline',
    'a-Usermanagement-filled': 'user-management--filled',
    'a-Businesscompetitor-outlined': '',
    'a-Businesscompetitor-filled': '',
    'a-Enterpriseuser-filled': 'enterprise-user',
    'a-Enterpriseuser-outlined': 'enterprise-user',
    'a-Chartbubble-outlined': 'chart--bubble--outline',
    'a-Chartbubble-filled': 'chart--bubble--filled',
    'a-Trafficstatistics-outlined': '',
    'a-Trafficstatistics-filled': '',
    'Database-filled': 'data--base',
    'Database-outlined': 'data--base',
    'a-Databaseaddition-outlined': '',
    'a-Databaseaddition-filled': '',
    'a-Parentchild-outlined': 'parent-child--outline',
    'a-Parentchild-filled': 'parent-child--filled',
    'Chart-outlined': 'chart--outline',
    'Chart-filled': 'chart--filled',
    'a-Piechart-outlined': 'chart--pie--outline',
    'a-Piechart-filled': 'chart--pie--filled',
    'Dashboard-outlined': '',
    'Dashboard-filled': '',
    'Document-outlined': 'document--outline',
    'Document-filled': 'document--filled',
    'a-Documentadd-outlined': 'document--add',
    'a-Documentadd-filled': 'document--add',
    'Copy-1-outlined': 'copy--outline',
    'Copy-1-filled': 'copy--filled',
    'Copy-2-outlined': 'copy--outline',
    'Copy-2-filled': 'copy--filled',
    'a-Queryfile-outlined': '',
    'a-Queryfile-filled': '',
    'Folder-outlined': 'folder--outline',
    'Folder-filled': 'folder--filled',
    'a-Folderadd-outlined': 'folder--add--outline',
    'a-Folderadd-filled': 'folder--add--filled',
    'a-Openfolder-outlined': 'folder--open',
    'a-Openfolder-filled': 'folder--open',
    'Data-outlined': '',
    'Data-filled': '',
    'a-Videofile-outlined': '',
    'a-Videofile-filled': '',
    'Blacklist-outlined': '',
    'Blacklist-filled': '',
    'a-Passengerdetails-outlined': '',
    'a-Passengerdetails-filled': '',
    'Security-outlined': 'security--outline',
    'Security-filled': 'security--filled',
    'Export-outlined': 'export',
    'Export-filled': 'export',
    'Download-outlined': 'download',
    'Download-filled': 'download',
    'Upload-outlined': 'upload',
    'Upload-filled': 'upload',
    'PDF-outlined': '',
    'PDF-filled': '',
    'ZIP-filled': '',
    'ZIP-outlined': '',
    'XLS-filled': '',
    'XLS-outlined': '',
    'WORD-filled': '',
    'WORD-outlined': '',
    'PNG-filled': '',
    'PNG-outlined': '',
    'EXL-filled': '',
    'EXL-outlined': '',
    'PPT-filled': '',
    'PPT-outlined': '',
    'NPS-filled': '',
    'NPS-outlined': '',
    'Withdraw-filled': '',
    'Withdraw-outline': '',
    'Http-filled': '',
    'Http-outline': '',
    'Confirm-filled': '',
    'Confirm-outline': '',
    'Questionnaire-filled': '',
    'Questionnaire-outline': '',
    'Idea-outlined': 'idea--outline',
    'Idea-filled': 'idea--filled',
    'a-Airportlocation-outlined': '',
    'a-Airportlocation-filled': '',
    'Map-outlined': 'map--outline',
    'Map-filled': 'map--filled',
    'Location-outlined': 'location--outline',
    'Location-filled': 'location--filled',
    'a-Regionalthermal-outlined': '',
    'a-Regionalthermal-filled': '',
    'a-Usealineseparating-outlined': '',
    'a-Usealineseparating-filled': '',
    'Atm-filled': '',
    'Atm-outlined': '',
    'a-Officialproprietary-filled': '',
    'a-Officialproprietary-outlined': '',
    'a-Thirdparty-filled': '',
    'a-Thirdparty-outlined': '',
    'Print-outlined': 'printer--outline',
    'Print-filled': 'printer--filled',
    'a-Downtobottom-outlined': 'down-to-bottom',
    'a-Downtobottom-filled': 'down-to-bottom',
    'a-Uptotop-outlined': 'up-to-top',
    'a-Uptotop-filled': 'up-to-top',
    'Attachment-outlined': 'attachment',
    'Attachment-filled': 'attachment',
    'Text-outlined': '',
    'Text-filled': '',
    'WIFI-outlined': 'wifi',
    'WIFI-filled': 'wifi',
    'Wikis-outlined': '',
    'Wikis-filled': '',
    'Arrow-double-right-filled': '',
    'Arrow-double-left-filled': '',
    'Arrow-double-left-outlined': '',
    'Arrow-double-right-outlined': ''
};
/**
 * Return a parsed type if the type is from B-Design icon v2.0.
 * Return an empty string if the legacy type cannot be parsed.
 * Return the input type if the type is from v3.0.
 * @param type
 * @returns The parsed type.
 */
export const parseLegacyNames = (type) => {
    return LEGACY_ICON_TO_3[type];
};
